import {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {SubmissionError} from 'redux-form';
import {useToasts} from 'react-toast-notifications';
import SMSKeyForm from '../shared/sms-key-form';
import ErrorMessage from '../shared/error-message';
import {checkSMSKeyRequest, sendSMSKeyRequest} from '../../redux/actions/user';
import {Button, Divider, Segment} from 'semantic-ui-react';
import {Link} from 'react-router-dom';

function MobileVerification(props) {
  const [isOk, setIsOk] = useState(false);
  const [uid, setUID] = useState(null);
  const [error, setError] = useState(null);

  const {addToast} = useToasts();

  if (error) return (<ErrorMessage message={error}/>);

  if (!isOk) return (
    <Segment>
      <div className='text-center text-large'>
        <p>
          شماره تلفن همراه:
          {' '}
          {props.mobile}
        </p>
        <Button
          basic
          primary
          content='تایید شماره تلفن همراه'
          onClick={async function () {
            await sendSMSKey(props.mobile, props.sendSMSKeyRequest, setUID, setError);
            setIsOk(true)
          }}
        />
        <Divider className='my-4'/>
        <p>در صورت مغایرت شماره تلفن گزینه تغییر شماره تلفن همراه را انتخاب نمایید.</p>
        <Button basic primary content='تغییر شماره تلفن همراه' as={Link} to='/profile/update-mobile'/>
      </div>
    </Segment>
  )

  return (
    <SMSKeyForm
      showTitle={false}
      mobile={props.mobile}
      onSubmit={async function (smsKey) {
        await props.checkSMSKeyRequest(uid, smsKey);
        props.onSuccess();
        setIsOk(false)
        addToast('شماره تلفن همراه با موفقیت تایید شد.', {appearance: 'success'});
      }}
      onResend={async function () {
        const {payload: {uid}} = await props.sendSMSKeyRequest(props.mobile);
        setUID(uid);
      }}
      onError={setError}
    />
  );
}

async function sendSMSKey(mobile, sendSMSKeyRequest, setUID, setError) {
  try {
    const {payload: {uid}} = await sendSMSKeyRequest(mobile);
    setUID(uid);
  } catch (error) {
    if (error.status === 403) {
      setError('محدودیت ارسال کد تایید شما به پایان رسیده است،');
    } else {
      const errorMessage = error.message || 'ارسال کد تایید به شماره تلفن همراه انجام نشد.';
      throw new SubmissionError({_error: errorMessage});
    }
  }
}

function mapStateToProps({user}) {
  return {mobile: user.data.mobile};
}

MobileVerification.propTypes = {
  mobile: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired
};

export default connect(mapStateToProps, {sendSMSKeyRequest, checkSMSKeyRequest})(MobileVerification);
